
import { Base } from '../../components/base-component';

import './calculators-businessloans-v2.component.scss';
import { TooltipsService } from '../../services/tooltips.service';
import * as $ from 'jquery';

export class CalculatorsBusinessloansV2 extends Base {

	timeout: any = null;

	inputs: Element[];

	expensesModal: Element[];

	calculatorSubmit: Element[];
	calculatorReset: Element[];
	calculator: HTMLFormElement;

	formValid: boolean = true;

	// termChecker: HTMLFormElement[];

	constructor(element: Element) {
		super(element);
	}

	init() {
		
		this.inputs = Array.from(this.element.querySelectorAll('input'));
		this.calculatorSubmit = Array.from(this.element.querySelectorAll('.js-calculator-blc-calculate'));
		this.calculatorReset = Array.from(this.element.querySelectorAll('.js-calculator-blc-reset'));
		this.calculator = this.element.querySelector('form') as HTMLFormElement;

		this.removeStepsOnMobile();
		TooltipsService.initTooltips();
	}

	bindEvents() {

		this.calculatorSubmit.map((item) => item.addEventListener('click', (event) => {
			// animate to top
			
			let btnDoIQualify = Array.from(this.element.querySelectorAll('.js-calculator-do-i-qualify'));

			if ($(window).width() > 768) {
				$('html,body').animate({
					scrollTop: $('div.calculators').offset().top - 10
				}, 'slow');

				btnDoIQualify.forEach(element => {
					element.classList.remove('button--white');
					element.classList.remove('button--border-blue');
					element.classList.add('gradient-orange');
				});
			} else if ($(window).width() < 768) {
				$('html,body').animate({
					scrollTop: $('div.calculator-item__box').offset().top
				}, 'slow');
				
				setTimeout(function(){ 
					btnDoIQualify.forEach(element => {
						element.classList.remove('button--white');
						element.classList.remove('button--border-blue');
						element.classList.add('gradient-orange');
					});
				}, 800);
			}
			
			if (this.formValid) {
				const button : any = event.currentTarget;

				const form =  button.closest("form");

				this.doBLC(form)
				// Analytics - Trigger form Complete when the user calculates the results
				this.analyticsService.dtmFormComplete("complete", "");
			}
		}));

		this.calculatorReset.map((item) => item.addEventListener('click', (event) => {
			this.resetInputs(event)
			// animate back to top
			if ($(window).width() < 768) {
				$('html,body').animate({
					scrollTop: $('div.calculators').offset().top - 10
				},
					'slow');
			}

			let btnDoIQualify: HTMLElement[] = Array.from(document.querySelectorAll('.js-calculator-do-i-qualify'));

			btnDoIQualify.forEach(element => {
				element.classList.remove('gradient-orange');
				element.classList.add('button--white');
				element.classList.add('button--border-blue');
			});

		}));

		// INPUTS
		this.inputs.map((item) => item.addEventListener('focusin', (event) => {
			this.onFocusInput(event);
		}));

		this.inputs.map((item) => item.addEventListener('focusout', (event) => {
			this.outFocusInput(event);
			this.validationService.validateCalculator(event, this.calculatorSubmit);
			let _valid: Element[] = Array.from(this.element.querySelectorAll('.calculator-form__error'));

			if (_valid.length > 0) {
				this.formValid = false;
				this.calculatorSubmit.map((item) => {
					item.classList.add('button--disabled');
				});
			} else {
				this.formValid = true;
				this.calculatorSubmit.map((item) => {
					item.classList.remove('button--disabled');
				});
			}
		}));

		this.inputs.map((item) => item.addEventListener('keyup', (event) => {
			this.keyInput(event);
		}));

		window.addEventListener('resize', this.removeStepsOnMobile);
	}

	removeStepsOnMobile() {
		let btnDoIQualify = Array.from(document.querySelectorAll('.js-calculator-do-i-qualify'));
		let steps = Array.from(document.querySelectorAll('span.calculator-form__button-step'));

		if (window.outerWidth < 768) {
			if (steps) {
				for (var i = 0; i < steps.length; i++) {
					steps[i].remove();
				}
			}
			btnDoIQualify.forEach(element => {
				let newElem = element as HTMLFormElement;
				newElem.style.marginTop = "25px";
			});
		}
	}

	resetInputs(event) {
		event.preventDefault();

		let errorLabels = Array.from(this.calculator.querySelectorAll('div.form__group'));
		errorLabels.map((item: any) => {
			let parent: any = item;
			$(parent).removeClass('calculator-form__error');
			$(parent).find('div.calculator-form__error-label').remove();
		});

		let calculatorForms = Array.from(this.element.querySelectorAll('form'));
		calculatorForms.forEach(element => {
			element.reset();
		});
		this.calculator.reset();
		this.formValid = true;
		this.resetValues(this.calculator);

		this.inputs.map((item: any) => {
			if (item.getAttribute('type') != 'radio') {
				item.setAttribute('data-value', 0);
				item.setAttribute('placeholder', 0);
			}
		});

		// Analytics - Trigger form Complete when the user calculates the results
		this.analyticsService.dtmRestartForm();

	}

	onFocusInput(event) {
		event.preventDefault();
		let field: any = event.target;
		let _value = parseFloat(field.value);
		let min = parseFloat(field.getAttribute('min'));
		let max = parseFloat(field.getAttribute('max'));
		if (min && max) {
			if ((_value < min) && (_value > max)) {
				field.value = "";
			}
		} else {
			if (_value == 0) {
				field.value = "";
			}
		}
	}

	outFocusInput(event) {
		event.preventDefault();
		let field: any = event.target;

		if (!field.classList.contains('js-copy-field')) {
			let value = field.getAttribute('data-value');
			// field.value = value;
			if (field.value == '') {
				field.value = value;
			}
		}

		if (field.value == '') {
			field.value = 0;
		}
	}

	keyInput(event) {
		event.preventDefault();
		this.formValid = true;
		let field: any = event.target;
		let value = field.value;

		if (!field.classList.contains('js-copy-field')) {
			field.setAttribute('data-value', value);
			field.setAttribute('placeholder', value);
		}

		this.formValid = this.validationService.validateCalculator(event, this.calculatorSubmit);
	}

	//CALCULATOR SERVICES
	doBLC(form: HTMLFormElement) {
		let total: number = 0;
		const loanamount: any = form.querySelector('input[name=loan_amount]');
		total = parseFloat(loanamount.value)
		const interest: any = form.querySelector('input[name=variable_interest_rate]');
		const term: any = form.querySelector('input[name=term]');
		const output_loan_amount: any = document.querySelectorAll('span.js-calculator-loan-amount-blc1');
		const output_borrow: any = document.querySelectorAll('span.js-calculator-estimated-repayment-blc1');
		const output_months: any = document.querySelectorAll('span.js-calculator-loan-period-blc1');
		const output_date: any = document.querySelectorAll('span.js-calculator-first-repayment-date-blc1');
		const output_fees: any = document.querySelectorAll('span.js-calculator-total-interest-blc1');

		const answer = this.PLTMonthlyRepayments(total, interest.value, term.value);
		[].slice.call(output_loan_amount).forEach(function (div) {
			div.innerHTML = answer.loanamount;
		});
		[].slice.call(output_borrow).forEach(function (div) {
			div.innerHTML = answer.estimatedMonthlyRepayment;
		});
		[].slice.call(output_date).forEach(function (div) {
			div.innerHTML = answer.date;
		});
		[].slice.call(output_fees).forEach(function (div) {
			div.innerHTML = answer.totalInterest;
		});

		
	}

	// BUSINESS LOANS
	PLTMonthlyRepayments(
		loanamount: number = 0,
		loaninterest: number = 0,
		loanterm: number = 10.25
	) {
		const initiationFee: number = Math.min(1050, 165 + 0.1 * (loanamount - 1000)) * 1.15;
		const serviceFee: number = 60 * 1.15;

		let normalValue: number = loanamount / loanterm;
		normalValue = this.round(normalValue, 2);

		let monthlyLoanRepayments: number = -this.pmt_vaf(loaninterest / 1200, loanterm, (loanamount + initiationFee), loanterm, 0) + serviceFee;
		monthlyLoanRepayments = this.round(monthlyLoanRepayments, 2);

		let finalTotalInterestCharge = this.cumipmt2(loaninterest / 1200, loanterm, (loanamount + initiationFee), 1, loanterm, 0);

		let todaysDate: any = new Date();
		let getMonth: number = todaysDate.getMonth();
		todaysDate.setMonth(getMonth + 1, 1);
		const monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

		return {
			loanamount: this.formatter(loanamount),
			date: "1 " + monthNames[todaysDate.getMonth()] + " " + todaysDate.getFullYear(),
			iFee: initiationFee,
			sFee: serviceFee,
			totalInterest: this.formatter(finalTotalInterestCharge),
			estimatedMonthlyRepayment: this.formatter(monthlyLoanRepayments)
		};
	}

	round(expr, decplaces) {
		let decpoint, str;
		str = '' + Math.round(expr * Math.pow(10, decplaces));
		while (str.length <= decplaces) {
			str = '0' + str;
		}
		decpoint = str.length - decplaces;
		return parseFloat(str.substring(0, decpoint) + '.' + str.substring(decpoint, str.length));
	}

	pmt_vaf(rate: number = 0, period: number = 0, value: number = 0, futurevalue: number = 0, type: number = 0) {
		if (!futurevalue) futurevalue = 0;
		if (!type) type = 0;

		if (rate == 0) return -(value + futurevalue) / period;

		var pvif = Math.pow(1 + rate, period);
		var pmt = rate / (pvif - 1) * -(value * pvif + futurevalue);
		if (type == 1) {
			pmt /= (1 + rate);
		};

		return pmt;
	}

	cumipmt2(rate: number = 0, periods: number = 0, value: number = 0, start: number = 0, end: number = 0, type: number = 0) {
		let i, interest, payment;
		payment = this.pmt_cumipmt(rate, periods, value, 0, type);
		interest = 0;
		if (start === 1) {
			if (type === 0) {
				interest = -value;
				start++;
			}
		}
		i = start;
		while (i <= end) {
			if (type === 1) {
				interest += this.fv(rate, i - 2, payment, value, 1) - payment;
			} else {
				interest += this.fv(rate, i - 1, payment, value, 0);
			}
			i++;
		}
		interest *= rate;
		return -interest;
	}
	fv(rate: number = 0, periods: number = 0, payment: number = 0, value: number = 0, type: number = 0) {
		let result, term;
		value = value || 0;
		type = type || 0;
		result = void 0;
		if (rate === 0) {
			result = value + payment * periods;
		} else {
			term = Math.pow(1 + rate, periods);
			if (type === 1) {
				result = value * term + payment * (1 + rate) * (term - 1) / rate;
			} else {
				result = value * term + payment * (term - 1) / rate;
			}
		}
		return -result;
	}
	pmt_cumipmt(rate: number = 0, periods: number = 0, present: number = 0, future: number = 0, type: number = 0) {
		let result, term;
		future = future || 0;
		type = type || 0;
		result = void 0;
		if (rate === 0) {
			result = (present + future) / periods;
		} else {
			term = Math.pow(1 + rate, periods);
			if (type === 1) {
				result = (future * rate / (term - 1) + present * rate / (1 - (1 / term))) / (1 + rate);
			} else {
				result = future * rate / (term - 1) + present * rate / (1 - (1 / term));
			}
		}
		return -result;
	}

	// FORMATTERS
	formatter(value) {
		return parseFloat(value).toFixed(0).replace(/(\d)(?=(\d{3})+$)/g, '$1 ');
	}

	// RESET VALUES	- OUTPUTS
	resetValues(form: HTMLFormElement) {
		switch (form.id) {

			// case 'calculator-personal_loans_test':
			case 'calculator-business_loans_v2':
				const loanamount: any = form.querySelector('input[name=loan_amount]');
				const output_loan_amount: any = document.querySelectorAll('span.js-calculator-loan-amount-blc1');
				const output_borrow_blc1: any = document.querySelectorAll('span.js-calculator-estimated-repayment-blc1');
				const output_date: any = document.querySelectorAll('span.js-calculator-first-repayment-date-blc1');
				const output_fees: any = document.querySelectorAll('span.js-calculator-total-interest-blc1');
				[].slice.call(loanamount).forEach(function (div) {
					div.innerHTML = '300000';
				});
				[].slice.call(output_loan_amount).forEach(function (div) {
					div.innerHTML = '0';
				});
				[].slice.call(output_borrow_blc1).forEach(function (div) {
					div.innerHTML = '0';
				});
				[].slice.call(output_date).forEach(function (div) {
					div.innerHTML = '0';
				});
				[].slice.call(output_fees).forEach(function (div) {
					div.innerHTML = '0';
				});
				break;

			default:
				break;
		}
	}

}



// WEBPACK FOOTER //
// ./components-wpbbsa/calculators-businessloans-v2/calculators-businessloans-v2.component.ts